export enum TimeLimitType {
  Repeating = 'Repeating',
  FixedDates = 'FixedDates',
}

export interface RepeatingTimeLimit {
  type: TimeLimitType.Repeating;
  startDate: number;
  duration: number;
  startedAt?: number;
  toLocalTime?: boolean;
  repeatsEvery: number;
}

export interface FixedDatesTimeLimit {
  type: TimeLimitType.FixedDates;
  startDate: number;
  endDate: number;
  cutOffPoint?: number;
  toLocalTime?: boolean;
  startedAt?: number;
}

export type TimeLimit = RepeatingTimeLimit | FixedDatesTimeLimit;

export interface TimeLimitHandler {
  getStartDate(): number;
  canStart(): boolean;
  getEndDate(): number;
  hasEnded(): boolean;
}
